import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

/**
 * Componente para exibicao de mensagem de permissao negada
 * Implementa acessibilidade WCAG 2.1 AA
 */
@Component({
  selector: 'app-no-permission',
  templateUrl: './no-permission.component.html',
  styleUrls: ['./no-permission.component.css']
})
export class NoPermissionComponent implements OnInit {
  attemptedRoute: string = '';
  title: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.attemptedRoute = params['attemptedRoute'] || '';
      this.setTitle();
    });
  }

  /**
   * Define o título com base na rota e tradução
   */
  private setTitle(): void {
    const featureKey = this.attemptedRoute.startsWith('/')
      ? this.attemptedRoute.substring(1)
      : this.attemptedRoute;

    this.translateService.get([`NO_PERMISSION.TITLE`, `NO_PERMISSION.TITLE_FEATURE`, `NO_PERMISSION.FEATURE.${featureKey}`]).subscribe(translations => {
      const title = translations[`NO_PERMISSION.TITLE`] || 'Você não tem autorização para acessar';
      const titleFeature = translations[`NO_PERMISSION.TITLE_FEATURE`] || '';
      let featureTranslation = translations[`NO_PERMISSION.FEATURE.${featureKey}`];

      // Fallback para featureTranslation caso não exista ou seja igual à chave
      featureTranslation = featureTranslation && featureTranslation !== `NO_PERMISSION.FEATURE.${featureKey}`
        ? featureTranslation
        : this.attemptedRoute;

      // Verifica se o resultado começa com EN4_ ou FM6_ e busca a tradução com .TRANSLATION
      if (featureTranslation.startsWith('EN4_') || featureTranslation.startsWith('FM6_')) {
        this.translateService.get(`${featureTranslation}.TRANSLATION`).subscribe(translation => {
          this.title = `${title}: ${translation || featureTranslation}`;
        });
      } else {
        this.title = `${title}: ${featureTranslation}`;
      }
    });
  }

  /**
   * Navega para a pagina inicial
   */
  goHome(): void {
    this.router.navigate(['/']);
  }
}
